import React, { FC, HTMLAttributes } from 'react'

import clsx from 'clsx'

export type ThemeLayouts = 'base' | 'oneColumn' | 'twoColumn' | 'threeColumn' | 'sidebar'

export interface LayoutProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Type of layout
   */
  theme?: ThemeLayouts
  /**
   * Sets max-width
   */
  container?: 'full' | 'none'
}

export const LayoutStyle = {
  _: 'grid gap-x-6 gap-y-8',
  container: {
    full: 'max-w-screen-2xl w-full px-6 py-8 mx-auto',
    none: ''
  },
  theme: {
    base: 'sm:grid-cols-4 md:grid-cols-8 lg:grid-cols-12',
    oneColumn: 'grid-cols-1',
    sidebar: 'sm:grid-cols-1 md:grid-cols-2-1',
    threeColumn: 'sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    twoColumn: 'sm:grid-cols-1 md:grid-cols-2'
  }
}

// Please do not use types off of a default export module or else Storybook Docs will suffer.
// see: https://github.com/storybookjs/storybook/issues/9556
/**
 * Layout - Layout provides a simple interface to create responsive 12 column grid layout. It renders a div element with display: grid.
 */
export const Layout: FC<LayoutProps> = React.forwardRef<HTMLDivElement, LayoutProps>(
  ({ className, container = 'full', theme = 'oneColumn', ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={clsx(className, LayoutStyle._, LayoutStyle.theme[theme], LayoutStyle.container[container])}
      />
    )
  }
)
